import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IProductCategoriesStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IProductCategoriesStatsResponse>,
  IPathBaseParam,
  object
>("stores.productCategories.stats");

export const stats = {
  ...getApis,
};
